import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const EndCTASection = styled.section`
  background: radial-gradient(
    ellipse 90% 120% at 50% 0%,
    #0f555c 0%,
    #0a282d 46%,
    ${homeColor.bg} 85%
  );
  text-align: center;
  border-top: 1px solid ${homeColor.carbon};
  padding: ${(props) =>
    props.$variant === 'bottom' ? '60px 0' : '50px 0 40px'};

  ${screen.md} {
    padding: ${(props) =>
      props.$variant === 'bottom' ? '80px 0' : '60px 0 50px'};
  }

  ${screen.lg} {
    padding: ${(props) => (props.$variant === 'bottom' ? '100px 0' : '60px 0')};
  }
`;

export const Title = styled.h2`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.08;
  font-size: 32px;
  margin: 0 auto 16px;
  max-width: 680px;
  color: ${homeColor.white};

  ${screen.md} {
    font-size: 42px;
    max-width: 890px;
  }

  ${screen.lg} {
    font-size: 50px;
    max-width: 1060px;
  }
`;

export const Copy = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 17px;
  margin: 0 auto 30px;
  max-width: 380px;
`;
